angular.module('impactx.rfq').controller('RFQChangeItemCtrl', [
    '$scope',
    'dataGen',
    'TranslationService',
    'themeFactory',
    '$redirect',
    '$routeParams',
    'ToastService',
    '$mdDialog',
    'headerLabel',
    'item',
    'isBuyer',
    RFQChangeItemCtrl
]);

function RFQChangeItemCtrl($scope, dataGen, TranslationService, themeFactory, $redirect, $routeParams, ToastService,
                           $mdDialog, headerLabel, item, isBuyer) {
    $scope.abortLabel = TranslationService.get("abort");
    $scope.acceptLabel = TranslationService.get("accept");
    $scope.requiredLabel = TranslationService.get("required");
    $scope.noSelectedItemMessageLabel = TranslationService.get("noSelectedItemMessage");
    $scope.theme = themeFactory.getTheme();

    $scope.headerLabel = headerLabel;
    $scope.item = item;
    $scope.isBuyer = isBuyer;

    this.cancel = function () {
        $mdDialog.cancel();
    };

    this.accept = function () {
        if (!isBuyer) {
            dataGen.postAsForm({}, {item: $scope.item}, "/rfq/updateditemprice").then(function (data) {
                $mdDialog.hide(data);
            });
        }
        else {
            $mdDialog.hide($scope.item);
        }
    };
}